import { render, staticRenderFns } from "./GptFeaturesMenu.vue?vue&type=template&id=a72473ec&"
import script from "./GptFeaturesMenu.vue?vue&type=script&lang=js&"
export * from "./GptFeaturesMenu.vue?vue&type=script&lang=js&"
import style0 from "./GptFeaturesMenu.vue?vue&type=style&index=0&id=a72473ec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports